import InsuranceConfirmationStep from './InsuranceConfirmationStep.component';
import InsuranceConfirmationStepPage from './InsuranceConfirmationStep.page';

export default InsuranceConfirmationStepPage;

export { InsuranceConfirmationStep };
